/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';
import { DeviceCommand } from './deviceCommand';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface CustomerNewRemoteCommandDto { 
    idDevice?: number;
    deviceClassWithOwnIdPool?: CustomerNewRemoteCommandDto.DeviceClassWithOwnIdPoolEnum;
    parameterDataList?: Array<ParameterData>;
    schedules?: Array<Schedule>;
    deviceCommand?: DeviceCommand;
    virtualFenceConstructionRules?: Array<VirtualFenceConstructionRule>;
}
export namespace CustomerNewRemoteCommandDto {
    export const DeviceClassWithOwnIdPoolEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassWithOwnIdPoolEnum = typeof DeviceClassWithOwnIdPoolEnum[keyof typeof DeviceClassWithOwnIdPoolEnum];
}


